import { render, staticRenderFns } from "./ClinicalTrials.vue?vue&type=template&id=85723b9e"
import script from "./ClinicalTrials.vue?vue&type=script&lang=js"
export * from "./ClinicalTrials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports